import { useEffect, useState } from "react";
import BasicWrapper from "../../components/basicWrapper/basicWrapper";
import ExtendedWrapper from "../../components/extendedWrapper/extendedWrapper";
import { IvnoiceContextProvider } from "./createInvoiceContext";

import "./steps/createInvoice.css"
//
import CreateInvoiceWrapperExtended from "./createInvoiceWrapperExtended";

import StepsHeader from "./steps/utils/stepsHeader";

export default function CreateInvoiceWrapper() {
    const [invoiceStep, setInvoiceStep] = useState(0);
    const [maxStep, setMaxStep] = useState(1);
    const [skipCalc, setSkipCalc] = useState(false);

    // Update max step by 1 when reaching current max step
    useEffect(() => {
        if (maxStep === 6) return;
        if (invoiceStep >= maxStep) setMaxStep(maxStep + 1);
    }, [invoiceStep]);


    return (
        <>
        <StepsHeader skipCalc={skipCalc} step={invoiceStep} setInvoiceStep={setInvoiceStep} maxStep={maxStep} />
        <BasicWrapper>
            <IvnoiceContextProvider>
                <CreateInvoiceWrapperExtended
                    skipCalc={skipCalc} setSkipCalc={setSkipCalc}
                    invoiceStep={invoiceStep} setInvoiceStep={setInvoiceStep}
                    maxStep={maxStep} setMaxStep={setMaxStep} />
            </IvnoiceContextProvider>
        </BasicWrapper>
        </>
    )
}